import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserorderService } from "../../core/services/userorder.service";
import { OrderIdentifier } from "../../core/enums/OrderIdentifers.enum";
import * as moment from 'moment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MERCHANT_ORDER_EXPORT_MAX_DATE_RANGE } from "../../shared/constant"

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  title = 'datatables';
  dtOptions: DataTables.Settings = {};

  dateTimeRange: Date[];
  maxDateRange = new Date();

  status = '';
  abc = {};
  refundedabc = {};
  partially_payedabc = {};
  failedabc = {};
  pendingabc = {};
  canceledabc = {};
  successabc = {};
  stringifiedData = null;
  stringJson: any;
  stringObject: any;
  item = [{}];
  successOrder = [];
  refundedOrder = [];
  pendingOrder = [];
  failedOrder = [];
  canceledOrder = [];
  processRefoundOrder = [];
  confirmrefund = "Confirm refund";
  confirmcancel = "Confirm cancel";
  cancel = "CANCEL";
  dnone = 'd-block';
  authorizezone = 'd-block';
  auauthorize = 'd-none';
  processCancelOrder = [];
  error = '';
  merchantsListval = [{}];
  currentPage: any;
  searchkeyword = {};
  pagination = {};
  Articles: any;
  page = 1;
  count = 0;
  tableSize = 10;
  totalPages;
  tableSizesArr = [10, 15, 25];
  availability = 'd-none';
  merchantid = '';
  cashierid = "";

  orderSearchForm: FormGroup;
  orderIdentifiers: { key: string, value: string }[] = [];
  enablePagination: boolean = true;

  isOrderExportModalVisible: boolean = false;
  orderExportDateTimeRange: Date[];
  orderExportMaxDateRange: Date = new Date();
  orderExportErrorMessage: String = "";
  orderExportReceiverEmail: String = "";
  isOrderExportDisabled: boolean = false;

  constructor(
    private userorderService: UserorderService,
    private fb: FormBuilder) {

  }


  getFormattedDate(getDate) {
    const result = moment(getDate).add(330, 'minutes').format('ha Do MMMM, YYYY');
    return result;
  }


  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 2,
      info: false,
      searching: false,
      paging: false,
      processing: true,
      ordering: false
    };

    this.initializeOrderSearch();

    //console.log(this.datas);
    // select defualt tab

    localStorage.setItem('tab', 'S');

    this.success();

    this.merchantsList();

    this.merchantid = window.localStorage.getItem('merchantid');

  }

  initializeOrderSearch() {
    this.orderIdentifiers = Object.keys(OrderIdentifier).map(key => ({ key, value: OrderIdentifier[key] }));
    this.orderSearchForm = this.fb.group({
      identifier: ['', Validators.required],
      id: ['', Validators.required],
    });
  }


  // tabs

  successtab() {
    this.tableSizesArr = [10, 15, 25];
    this.page = 1;
    this.clearSearchForm();
    this.success();
    localStorage.setItem('tab', 'S');
  }


  refundedtab() {
    this.tableSizesArr = [10, 15, 25];
    this.page = 1;
    this.clearSearchForm();
    this.refunded();
    localStorage.setItem('tab', 'R');
  }



  pendingtab() {
    this.tableSizesArr = [10, 15, 25];
    this.page = 1;
    this.clearSearchForm();
    this.pending();
    localStorage.setItem('tab', 'P');
  }

  failedtab() {
    this.tableSizesArr = [10, 15, 25];
    this.page = 1;
    this.clearSearchForm();
    this.failed();
    localStorage.setItem('tab', 'F');
  }

  canceledtab() {
    this.tableSizesArr = [10, 15, 25];
    this.page = 1;
    this.clearSearchForm();
    this.canceled();
    localStorage.setItem('tab', 'C');
  }

  // pagination function

  successOrderfun(event) {
    this.page = event;

    this.success();
  }

  refundedOrderfun(event) {
    this.page = event;

    this.refunded();
  }

  pendingOrderfun(event) {
    this.page = event;

    this.pending();
  }

  failedOrderfun(event) {
    this.page = event;

    this.failed();
  }

  canceledOrderfun(event) {
    this.page = event;

    this.canceled();
  }

  // default funcation list

  tableData(event): void {

    this.tableSize = event.target.value;
    this.page = 1;

  }

  // table api call function

  success() {
    this.availability = 'd-none';
    this.currentPage = "FP";


    this.successabc = { status: "FP", pageNumber: this.page, pageSize: this.tableSize, merchantUserIdEnc: this.cashierid, sortProperty: "createdDate", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.successabc)
      .subscribe((data) => {

        this.successOrder = data['content'];
        this.pagination = data['pagination'].totalRecords;


        if (this.successOrder.length > 0) {
          this.availability = 'd-none';
        } else {
          this.availability = 'd-block';
        }
      },
        (err) => {

        }
      )
  }

  canceled() {
    this.availability = 'd-none';
    this.currentPage = "CAN";
    this.canceledabc = { status: "CAN", pageNumber: this.page, pageSize: this.tableSize, merchantUserIdEnc: this.cashierid, sortProperty: "createdDate", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.canceledabc)
      .subscribe((data) => {
        this.canceledOrder = data['content'];
        this.pagination = data['pagination'].totalRecords;

        if (this.canceledOrder.length > 0) {
          this.availability = 'd-none';
        } else {
          this.availability = 'd-block';
        }

      },
        (err) => {

        }
      )

  }

  pending() {
    this.availability = 'd-none';
    this.currentPage = "PEND";
    this.pendingabc = { status: "PEND", pageNumber: this.page, pageSize: this.tableSize, merchantUserIdEnc: this.cashierid, sortProperty: "createdDate", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.pendingabc)
      .subscribe((data) => {
        this.pendingOrder = data['content'];
        this.pagination = data['pagination'].totalRecords;

        if (this.pendingOrder.length > 0) {
          this.availability = 'd-none';
        } else {
          this.availability = 'd-block';
        }
      },
        (err) => {

        }
      )

  }

  failed() {
    this.availability = 'd-none';
    this.currentPage = "FL";
    this.failedabc = { status: "FL", pageNumber: this.page, pageSize: this.tableSize, merchantUserIdEnc: this.cashierid, sortProperty: "createdDate", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.failedabc)
      .subscribe((data) => {
        this.failedOrder = data['content'];
        this.pagination = data['pagination'].totalRecords;

        if (this.failedOrder.length > 0) {
          this.availability = 'd-none';
        } else {
          this.availability = 'd-block';
        }
      },
        (err) => {

        }
      )

  }

  partially_payed() {
    this.availability = 'd-none';
    this.currentPage = "PP";
    this.partially_payedabc = { status: "PP", pageNumber: this.page, pageSize: this.tableSize, sortProperty: "createdDate", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.partially_payedabc)
      .subscribe((data) => {
        this.item = data['content'];
        this.page = 1;

      }
      )

  }

  partially_refunded() {
    this.availability = 'd-none';
    this.currentPage = "PR";
    this.abc = { status: "PR", filter: this.getAPIFormattedDate() }

    this.userorderService
      .userorder(this.abc)
      .subscribe((data) => {
        this.item = data['content'];
        this.page = 1;


      }
      )

  }

  refunded() {
    this.availability = 'd-none';
    this.currentPage = "FR";
    this.refundedabc = {
      status: "FR",
      pageNumber: this.page,
      pageSize: this.tableSize,
      merchantUserIdEnc: this.cashierid,
      sortProperty: "createdDate",
      filter: this.getAPIFormattedDate()
    }

    this.userorderService
      .userorder(this.refundedabc)
      .subscribe((data) => {

        this.refundedOrder = data['content'];
        this.pagination = data['pagination'].totalRecords;

        if (this.refundedOrder.length > 0) {
          this.availability = 'd-none';
        } else {
          this.availability = 'd-block';
        }


      },
        (err) => {

        }
      )

  }

  // select merchant user

  merchantsList() {

    this.userorderService
      .merchants()
      .subscribe((data) => {

        this.merchantsListval = data['content'];

      }
      )
  }

  selectMerchant(merchnatID) {



    this.cashierid = merchnatID;
    localStorage.setItem('cashierid', merchnatID);
    this.page = 1;

    this.refreshTabs();
  }

  refreshTabs() {
    if (window.localStorage.getItem('tab') == 'S') {
      this.success();
    } else if (window.localStorage.getItem('tab') == 'C') {
      this.canceled();
    } else if (window.localStorage.getItem('tab') == 'P') {
      this.pending();
    } else if (window.localStorage.getItem('tab') == 'F') {
      this.failed();
    } else if (window.localStorage.getItem('tab') == 'R') {
      this.refunded();
    }
  }

  successhandlePageSizeChange(size) {
    this.page = 1;
    this.tableSize = size;
    this.success();


  }


  canceledhandlePageSizeChange(size) {
    this.page = 1;
    this.tableSize = size;
    this.canceled();


  }

  pendinghandlePageSizeChange(size) {
    this.page = 1;
    this.tableSize = size;
    this.pending();


  }
  failedhandlePageSizeChange(size) {
    this.page = 1;
    this.tableSize = size;
    this.failed();


  }


  refundedhandlePageSizeChange(size) {
    this.page = 1;
    this.tableSize = size;
    this.refunded();


  }

  processRefund(processRefund) {
    this.dnone = 'd-block';
    this.auauthorize = "d-none";
    this.processRefoundOrder = processRefund;
    this.confirmcancel = "Refund confirm";
  }

  orderRefoundRun(orderId) {

    this.userorderService
      .refund(orderId)
      .subscribe((data) => {

        if (data['statusCode'] == '200') {
          this.confirmrefund = 'Refund confirmed';
          this.cancel = 'CLOSE';
          this.dnone = 'd-none';
          this.success();
        };

      },
        (err) => {
          if (err['statusCode'] == '400') {
            this.auauthorize = 'd-block';
            this.error = err['validationFailures'][0].code;
          };
        }
      )
  }

  cancelPayment(pendingOrder) {
    this.dnone = 'd-block';
    this.auauthorize = "d-none";
    this.processCancelOrder = pendingOrder;
    this.confirmcancel = "Confirm cancel";

  }

  orderCancelRun(orderId) {

    this.userorderService
      .cancel(orderId)
      .subscribe((data) => {
        if (data['statusCode'] == '200') {
          this.confirmcancel = "Confirm Cancelled";
          this.cancel = 'CLOSE';
          this.dnone = 'd-none';
          this.pending();
        };
      },
        (err) => {
          if (err['statusCode'] == '400') {
            this.auauthorize = 'd-block';
            this.error = err['validationFailures'][0].code;
          };
        }

      )
  }

  // serach function 

  onKeypressEvent(key, orderIdSearchReq?) {
    this.searchkeyword = {
      status: this.currentPage,
      keyword: key,
      sortProperty: "createdDate",
      orderIdSearch: orderIdSearchReq,
      filter: this.getAPIFormattedDate()
    }

    //success
    if (this.currentPage == "FP") {
      if (key !== '' || orderIdSearchReq != null) {
        setTimeout(() => {
          this.userorderService
            .userorder(this.searchkeyword)
            .subscribe((data) => {
              this.successOrder = data['content'];
              this.pagination = data['pagination'].totalRecords;

              if (this.successOrder.length > 0) {
                this.availability = 'd-none';
              } else {
                this.availability = 'd-block';
              }
            }
            )
        }, 100);
      } else {
        this.success();
      }

    }

    //canceled
    if (this.currentPage == "CAN") {
      if (key !== '' || orderIdSearchReq != null) {
        setTimeout(() => {
          this.userorderService
            .userorder(this.searchkeyword)
            .subscribe((data) => {
              this.canceledOrder = data['content'];
              this.pagination = data['pagination'].totalRecords;

              if (this.canceledOrder.length > 0) {
                this.availability = 'd-none';
              } else {
                this.availability = 'd-block';
              }
            }
            )
        }, 100);
      } else {
        this.canceled();
      }

    }

    //pending
    if (this.currentPage == "PEND") {
      if (key !== '' || orderIdSearchReq != null) {
        setTimeout(() => {
          this.userorderService
            .userorder(this.searchkeyword)
            .subscribe((data) => {
              this.pendingOrder = data['content'];
              this.pagination = data['pagination'].totalRecords;

              if (this.pendingOrder.length > 0) {
                this.availability = 'd-none';
              } else {
                this.availability = 'd-block';
              }
            }
            )
        }, 100);
      } else {
        this.pending();
      }

    }

    // failed
    if (this.currentPage == "FL") {
      if (key !== '' || orderIdSearchReq != null) {
        setTimeout(() => {
          this.userorderService
            .userorder(this.searchkeyword)
            .subscribe((data) => {
              this.failedOrder = data['content'];
              this.pagination = data['pagination'].totalRecords;

              if (this.failedOrder.length > 0) {
                this.availability = 'd-none';
              } else {
                this.availability = 'd-block';
              }
            }
            )
        }, 100);
      } else {
        this.failed();
      }

    }

    // refundedOrder
    if (this.currentPage == "FR") {
      if (key !== '' || orderIdSearchReq != null) {
        setTimeout(() => {
          this.userorderService
            .userorder(this.searchkeyword)
            .subscribe((data) => {

              this.refundedOrder = data['content'];
              this.pagination = data['pagination'].totalRecords;

              if (this.refundedOrder.length > 0) {
                this.availability = 'd-none';
              } else {
                this.availability = 'd-block';
              }
            }
            )
        }, 100);
      } else {
        this.refunded();
      }

    }

  }

  searchOrder() {
    if (this.orderSearchForm.valid) {
      const orderIdSearchReq = {
        orderId: this.orderSearchForm.value.id,
        category: this.orderSearchForm.value.identifier
      }
      this.onKeypressEvent(null, orderIdSearchReq);
      this.enablePagination = false;
      return;
    }
    this.page = 1;
    this.onKeypressEvent(null, null);
  }

  clearDate() {
    this.dateTimeRange = [];
    this.searchOrder();
  }

  getAPIFormattedDate() {
    if (this.dateTimeRange && this.dateTimeRange.length == 2) {
      const startDateTime = this.dateTimeRange[0];
      const endDateTime = this.dateTimeRange[1];
      endDateTime.setHours(23);
      endDateTime.setMinutes(59);
      endDateTime.setSeconds(59);

      return {
        startDateTime: startDateTime.toISOString().replace(/\.000Z$/, ''),
        endDateTime: endDateTime.toISOString().replace(/\.000Z$/, ''),
      };
    }
    return null
  }

  clearSearchOrder() {
    this.clearSearchForm();
    this.refreshTabs();
  }

  clearSearchForm() {
    this.orderSearchForm.reset();
    const selectElement = document.getElementById('selectIdentifier') as HTMLSelectElement;
    selectElement.selectedIndex = 0;
    this.enablePagination = true;
  }

  openOrderExportModal() {
    this.orderExportDateTimeRange = [];
    this.orderExportReceiverEmail = "";
    this.toggleOrderExportModal();
  }

  orderExportDateRangeValidator(): void {
    const orderExportStartDate = this.orderExportDateTimeRange[0];
    const orderExportEndDate = this.orderExportDateTimeRange[1];
    this.orderExportReceiverEmail = "";
    if (orderExportStartDate && orderExportEndDate) {
      const diffInDays = Math.floor((orderExportEndDate.getTime() - orderExportStartDate.getTime()) / (24 * 3600 * 1000));
      this.orderExportErrorMessage = diffInDays < MERCHANT_ORDER_EXPORT_MAX_DATE_RANGE ? "" : `The date range must be within ${MERCHANT_ORDER_EXPORT_MAX_DATE_RANGE} days.`;
    } else {
      this.orderExportErrorMessage = "";
    }
    this.isOrderExportDisabled = false;
  }

  toggleOrderExportModal() {
    this.isOrderExportModalVisible = !this.isOrderExportModalVisible;
    this.isOrderExportDisabled = false;
  }

  submitOrderExport() {
    const localStartDateTime = this.orderExportDateTimeRange[0];
    const localEndDateTime = this.orderExportDateTimeRange[1]
    localEndDateTime.setHours(23);
    localEndDateTime.setMinutes(59);
    localEndDateTime.setSeconds(59);

    this.isOrderExportDisabled = true;
    this.userorderService
      .createMerchantUserOrderExport({
        merchantUserId: this.cashierid,
        filter: {
          status: this.currentPage,
          startDateTime: localStartDateTime.toISOString(),
          endDateTime: localEndDateTime.toISOString()
        }
      })
      .subscribe((data) => {
        const response = data['content'];
        this.orderExportReceiverEmail = response?.reportReceiverEmail;
      }, (error) => {
        this.orderExportErrorMessage = error['validationFailures']?.[0]?.code ? "We're sorry, but you've exceeded the allowed rate for exporting orders. Please try again later or contact support if you need further assistance." : "Sorry, something went wrong";
      })
  }
}